import React from 'react';
import styled from 'styled-components';
import {TscButtonType, Spinner} from '@techsmith/tsc-cloud-style-guide';
import {useTranslation} from 'react-i18next';
import {IComment} from '../../model/commentModel';
import {StyledWarning} from '../util/StyledElements';
import {SetupWorkerState} from '../../model/workerState';
import logging from '../../service/logging';
import {AlertModalPortal} from '../util/ModalPortalHelper';

const AlertModalWrapper = styled.div`
   button {
      height: 2rem;
   }
`;

const DeleteCommentAlert: React.FC<IDeleteCommentAlertProps> = ({comment, deleteComment, onClose, setShowDeleteAlert}) => {
   const {t} = useTranslation();
   const [loadingState, setLoadingState] = SetupWorkerState();

   const onDeleteClick = () => {
      try {
         setLoadingState({isWorking: true, hasError: false});
         deleteComment(comment);
         setLoadingState({isWorking: false, hasError: false});
         onClose();
      } catch (e) {
         logging.error('Failed to delete comment', e);
         setLoadingState({isWorking: false, hasError: true});
      }
   };

   return (
      <AlertModalWrapper>
         <AlertModalPortal
            title={t('conversations.deleteComment')}
            onClose={() => setShowDeleteAlert(false)}
            closeContent={t('general.cancel')}
            onConfirm={onDeleteClick}
            confirmContent={t('general.delete')}
            confirmButtonType={TscButtonType.destructive}
            onDismiss={() => setShowDeleteAlert(false)}
            dismissContent={t('general.cancel')}
            hideButtons={loadingState.isWorking}
            testId="delete-comment-alert"
         >
            <>
               {loadingState.hasError && (
                  <StyledWarning>
                     {t('conversations.warnings.deleteComment')}
                  </StyledWarning>
               )}
               {loadingState.isWorking && <Spinner />}
               {!loadingState.isWorking && t('conversations.confirmCommentDeletionText')}
            </>
         </AlertModalPortal>
      </AlertModalWrapper>
   );
};

export default DeleteCommentAlert;

export interface IDeleteCommentAlertProps {
   comment: IComment;
   deleteComment(comment: IComment): void;
   onClose(): void;
   setShowDeleteAlert(showDeleteAlert: boolean): void;
}
